module.exports = __webpack_public_path__ + "media/images/plans/plan-ceremony-course-meal-038d801e40c8f642dc541c4e86ef1bf1.png";